import { render, staticRenderFns } from "./formScreenSmsConfirm.vue?vue&type=template&id=293c7030&scoped=true"
import script from "./formScreenSmsConfirm.vue?vue&type=script&lang=js"
export * from "./formScreenSmsConfirm.vue?vue&type=script&lang=js"
import style0 from "./formScreenSmsConfirm.vue?vue&type=style&index=0&id=293c7030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293c7030",
  null
  
)

export default component.exports